var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSampleCollection = function SvgSampleCollection(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Sample Collection",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-1353.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sample-Collection",
    transform: "translate(1353.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,2 C19.5522847,2 20,2.44771525 20,3 C20,3.51283584 19.6139598,3.93550716 19.1166211,3.99327227 L19,4 L17.999,4 L18,16 C18,19.2383969 15.4344251,21.8775718 12.2249383,21.9958615 L12,22 C8.6862915,22 6,19.3137085 6,16 L6,16 L5.999,4 L5,4 C4.44771525,4 4,3.55228475 4,3 C4,2.48716416 4.38604019,2.06449284 4.88337887,2.00672773 L5,2 L19,2 Z M15.999,14 L7.999,14 L8,16 C8,18.0730923 9.57707765,19.7778384 11.5969395,19.9799449 L11.8003597,19.9951047 L12,20 C14.209139,20 16,18.209139 16,16 L16,16 L15.999,14 Z M16,4 L8,4 L7.999,12 L15.999,12 L16,4 Z",
    id: "Icons/24/Sample-Collection"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSampleCollection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sample-collection.b2d9292e79e48d0dd1ce1fad4ad38020.svg";